
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surfcamp",
      function () {
        return require("private-next-pages/surfcamp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surfcamp"])
      });
    }
  